import hljs from 'highlight.js';
import React from 'react';
import ReactDOM from 'react-dom'
import ShortContactForm from '@components/contact/short_contact_form';

window.addEventListener('DOMContentLoaded', function() {
  const hasCodeBlock = document.querySelectorAll('pre code');
  if (hasCodeBlock) {
    hljs.highlightAll();
  }
  const paragraphs = [...document.querySelectorAll('.blog-post-body-content p')];
  paragraphs.forEach((p) => {
    if (p.childNodes.length === 1) {
      const el0 = p.childNodes[0];
      if (el0.nodeName !== 'A' || !el0.classList.contains('btn')) return;
      p.classList.add('center');
    }
  });
  const elem = document.getElementById('contact-form');
  const titleProvider = elem.closest('[data-form-title]');
  const title = titleProvider?.dataset?.formTitle || undefined;

  ReactDOM.render(
    <form id="contact-form" action="/contact/submit" acceptCharset="UTF-8" method="post">
      <ShortContactForm place="blog_post" title={title} />
    </form>,
    elem
  );
}, { once: true });
